import type { RootState } from '../store'
import { SignalRUrls } from './constants'
import { signalRAdapter } from './signalrs'

const { selectById: selectConnectionByUrl } = signalRAdapter.getSelectors<RootState>(
  state => state.signalR,
)

export const selectMLConnection = (state: RootState) =>
  selectConnectionByUrl(state, SignalRUrls.MlHub)
export const selectProjectTreeConnection = (state: RootState) =>
  selectConnectionByUrl(state, SignalRUrls.ObjectTreeHub)
export const selectProgressConnection = (state: RootState) =>
  selectConnectionByUrl(state, SignalRUrls.PickerProgressHub)
export const selectSeismicImportProgressConnection = (state: RootState) =>
  selectConnectionByUrl(state, SignalRUrls.SeismicImportProgressHub)
export const selectGeoImportWorksConnection = (state: RootState) =>
  selectConnectionByUrl(state, SignalRUrls.GeoImportWorksHub)
